module.exports = "//cdn.mxpnl.com/static/asset-cache/3bf8e6571eabd28c5a82e79ed4467e24/iron/common/assets/images/customer-logos/lemonade-logo.png";